module.exports = __webpack_public_path__ + "img/IMPORT.204be2d4.svg";